<template>
  <v-select
    v-if="!isLoading"
    :items="items"
    v-model="model"
    label="Warehouse"
    item-text="name"
    item-value="id"
    :return-object=false
    :disabled="disabled"
    :rules="rules"
  ></v-select>
</template>

<script>
import { mapActions } from 'vuex';
export default {
  data() {
    return {
      mandatoryRules: [v => !!v || "This fiels is mandatory"],
      message: null,
      search: null,
      isLoading: false,
      items: []
    };
  },
  props: ["value", "disabled", "shopId", "rules"],
  computed: {
    model:{
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  },
  mounted: function() {
    this.getFittingType();
  },
  methods: {
    ...mapActions("warehouse",["list"]),
    getFittingType() {
      this.list()
        .then(data => {
          this.items = data.warehouses.data;
        });
    }
  }
};
</script>
